namespace GeniuzPOS.Inventory {
    export class IcStockAdjustInColumns {
        static columnsKey = 'Inventory.IcStockAdjustIn';
    }
}
